"use client"

import Image from "next/image";
import Link from "next/link";
import { useEffect, useState } from "react";
import PopUpModal from "./PopUpModal";

// import Logo from "@/assets/logo.svg";
// import WhiteLogo from "@/assets/logo_white.svg";

const Header = ({ isMainPage = true }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const [scrolled, setScrolled] = useState(false);

  const scrollTo = (id) => {
    const element = document.querySelector(id);
    if (element) {
      const offset = 100;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Clean up on unmount
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      {/* Mobile Navbar */}
      <nav className="xl:hidden sticky top-0 w-full z-50 bg-white shadow-md">
        <div className="container mx-auto flex items-center justify-between px-4 py-2">
          <Link href="/">
            <Image
              src="/icons/logo.svg"
              alt="Odoo ERP Implementation Company"
              width={150}
              height={30}
              priority
              placeholder='blur'
              blurDataURL="/svg-placeholder.jpg"
            />
          </Link>
          <button
            className="p-2 text-gray-700 focus:outline-none"
            onClick={toggleMenu}
            aria-label="Toggle navigation"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16m-7 6h7"
              ></path>
            </svg>
          </button>
        </div>
        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="bg-white px-12 pb-12">
            <ul className="flex flex-col space-y-4 text-center">
              {menuItems.map((item) => (
                <li key={item.id}>
                  <div
                    className="text-gray-700 hover:text-blue-600 cursor-pointer"
                    onClick={() => {
                      scrollTo(`#${item.id}`);
                      setIsMenuOpen(false);
                    }}
                  >
                    {item.name}
                  </div>
                </li>
              ))}
              <li>
                <PopUpModal exitIntent={true}>
                  <button
                    className="w-full mt-2 px-4 py-2 bg-[#511549] text-white rounded-md transition"
                    onClick={() => {
                      clickContactUs();
                      setIsMenuOpen(false);
                    }}
                  >
                    Claim Your 40-Hour Free Trial
                  </button>
                </PopUpModal>
              </li>
            </ul>
          </div>
        )}
      </nav>

      {/* Desktop Navbar */}
      <nav
        id="navbar-main"
        className={`hidden xl:block sticky top-0 w-full z-50 transition-colors duration-300 ${scrolled ? "bg-white shadow-md text-black" : "bg-[#511549] shadow-none text-white"
          }`}
      >
        <div
          id="navbar-top"
          className="w-[98%] max-w-[1600px] mx-auto flex items-center justify-between px-4 py-4"
        >
          <div id="logo">
            <Link href="/" className="logo">
              <Image
                src={scrolled ? "/icons/logo.svg" : "/icons/logo_white.svg"}
                alt="Odoo ERP Implementation Company"
                width={150}
                height={30}
                priority
                placeholder='blur'
                blurDataURL="/svg-placeholder.jpg"
              />
            </Link>
          </div>
          {isMainPage && (
            <div className="flex items-center space-x-6">
              <ul className="flex space-x-6">
                {menuItems.map((item) => (
                  <li key={item.id} className="nav-item">
                    <div
                      className="transition cursor-pointer text-[14px]"
                      onClick={() => scrollTo(`#${item.id}`)}
                    >
                      {item.name}
                    </div>
                  </li>
                ))}
              </ul>
              <PopUpModal exitIntent={true}>
                <button
                  className={`cursor-pointer px-4 py-2 text-[14px] rounded-md transition  ${scrolled ? "bg-[#511549] text-white" : "bg-white shadow-none text-[#511549]"}`}
                >
                  Request a Consultation
                </button>
              </PopUpModal>
            </div>
          )}
        </div>
      </nav>
    </>
  )
}

export default Header

const menuItems = [
  { name: "About Us", id: "about-us" },
  { name: "How We Work", id: "process" },
  { name: "What We Offer", id: "our-services" },
  { name: "Industries", id: "we-serve" },
  { name: "ERP Expertise", id: "our-erp-expertise" },
  { name: "Tech Stack", id: "our-tech-stack" },
  { name: "Why Codetrade", id: "why-choose-us" },
  { name: "Blogs", id: "blogs" },
];